import { fetchTokenAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const cyberhaven = defineConnector({
  identifier: "cyberhaven",
  name: "Cyberhaven",
  tagLine: "Data detection and response",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://[^/]*\\.cyberhaven\\.io/.*",
  auth: (app) =>
    fetchTokenAuth({
      request: {
        url: `https://${app.config.tenantUrl}/api/rest/v1/token/access`,
        jsonBody: {
          secret: app.secret.secretKey,
        },
      },
      extract: { from: "jsonPath", paths: ["access_token"] },
      apply: { kind: "header", scheme: "Bearer" },
    }),
  steps: [
    {
      title: "Create an API token",
      items: [
        {
          kind: "markdown",
          content:
            "In the Cyberhaven platform, navigate to **Preferences → Users and API keys**, click the **API Keys** tab, then click **New API Key**. Fill in the details and click **Save**. Copy the key from the confirmation window.",
        },
      ],
    },
    {
      title: "Paste your API key",
      items: [
        {
          kind: "input",
          label: "Secret key",
          required: true,
          target: { kind: "secrets", field: "secretKey" },
        },
      ],
    },
    {
      title: "Enter your tenant URL",
      items: [
        {
          kind: "hostname",
          label: "Tenant URL",
          placeholder: "mydomain.cyberhaven.io",
          required: true,
          target: { kind: "configuration", field: "tenantUrl" },
          helperText:
            "Your Cyberhaven instance URL, e.g. mydomain.cyberhaven.io",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ tenantUrl }) => `https://${tenantUrl}/api/rest/v2/dataset/list`,
  },
  publicEnvVars: ({ tenantUrl }) => ({
    CYBERHAVEN_URL: tenantUrl ? `https://${tenantUrl}` : "",
  }),
});
